import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import EditEvidenceForm from "../Forms/EditEvidenceForm";
import { Evidence } from "../evidence.types";
import CustomAttribute from "@/types/CustomAttribute";

interface HandleEditFinished {
  evidenceInfo: Evidence;
  newAttributes: CustomAttribute[];
  updateData: Partial<Evidence>;
}

interface EditEvidenceModalProps {
  open: boolean;
  handleClose: () => void;
  onEditSubmit: (data: HandleEditFinished) => void;
  defaultEvidenceInfo: Evidence | null;
}

export const EditEvidenceModal: FC<EditEvidenceModalProps> = ({
  open,
  handleClose,
  onEditSubmit,
  defaultEvidenceInfo,
}) => {
  const handleSubmit = (data: HandleEditFinished) => {
    onEditSubmit?.(data);
    handleClose();
  };

  const handleCancel = () => {
    handleClose();
  };

  if (!defaultEvidenceInfo) {
    return null;
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <EditEvidenceForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        defaultEvidenceInfo={defaultEvidenceInfo}
        width={700}
      />
    </Modal>
  );
};
